module.exports = function getResource(label) {
    let resources = {
        biUnavailable: 'Beauty Insider Points are not currently available. Please try again later.'
    };

    return resources[label];
};
